export enum CustomerIdType {
    Unknown,
    ThaiNational,
    Passport,
    ThaiForeignId,
};